import * as React from 'react';

interface ScrollViewProps {
  className?: string;
  children: React.ReactNode;
  scrollWithKeyboard?: boolean;
  style?: object;
}

const ScrollView: React.FunctionComponent<ScrollViewProps> = ({
  className,
  children,
  scrollWithKeyboard = false,
  ...rest
}) => {
  const scroller = React.useRef<HTMLDivElement>(null);

  function handleScrollKey(e: KeyboardEvent) {
    if (scrollWithKeyboard) {
      switch (e.keyCode) {
        case 34: // PageDown
        case 40: // ArrowDown
          scroller.current!.scrollTop += 250;
          break;
        case 33: // PageUp
        case 38: // ArrowUp
          scroller.current!.scrollTop -= 250;
          break;
        default:
          return;
      }
    }
  }

  React.useEffect(() => {
    window.addEventListener('keydown', handleScrollKey);
    return () => window.removeEventListener('keydown', handleScrollKey);
  });

  return (
    <div
      ref={scroller}
      className={`flex-auto w-100 overflow-y-auto touch-scroll ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
};

export default ScrollView;
